import { render, staticRenderFns } from "./RoomBedroomOffice.vue?vue&type=template&id=3ad06590&scoped=true"
import script from "./RoomBedroomOffice.vue?vue&type=script&lang=ts"
export * from "./RoomBedroomOffice.vue?vue&type=script&lang=ts"
import style0 from "./RoomBedroomOffice.vue?vue&type=style&index=0&id=3ad06590&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad06590",
  null
  
)

export default component.exports